module.exports = __webpack_public_path__ + "img/particle_motion_00093.f8ab7664.png";